import { ReactNode } from "react";
import { RequestStatus } from "../../types";
import styles from "./WaitlistRequests.module.scss";

export const statusOptions = Object.values(RequestStatus).map((status) => ({
  label: status
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase()),
  value: status,
}));

export const pageDomain = "waitlist-requests";

export const renderMap: Record<string, (value: any) => ReactNode> = {
  createdAt: (value) =>
    value
      ? new Date(value as string).toLocaleString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        })
      : "-",
  lastModified: (value) =>
    value
      ? new Date(value as string).toLocaleString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        })
      : "-",
  dateOfBirth: (value) => {
    if (value) {
      const date = value.split("-");
      return `${date[1]}/${date[2]}/${date[0]}`;
    }
    return "-";
  },
  status: (status) => <span className={[styles.status, styles[status.toLowerCase()]].join(" ")}>{status}</span>,
};
